import { DialogContent, Stack, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { CustomDialog, CustomDialogTitle } from "../../ui";
import QueenLogo from "../../assets/images/queen.png";

function ChampionBadgeInfoDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: (e: any) => void;
}) {
  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <CustomDialogTitle onClose={onClose}>
        <Stack direction="row" alignItems="baseline">
          <Typography variant="h6" mr={0.5}>
            leap.club champions
          </Typography>
          <Image
            src={QueenLogo}
            objectFit="contain"
            alt="queen"
            width={18}
            height={18}
          />
        </Stack>
      </CustomDialogTitle>
      <DialogContent sx={{ mb: 2 }}>
        <Typography variant="caption">
          champions are select industry leaders candidly sharing their
          experiences, wins, losses with other leap.club members for all of us
          to learn and win together.
          <br />
          <br />
          let&apos;s keep building that table.
        </Typography>
      </DialogContent>
    </CustomDialog>
  );
}

export default ChampionBadgeInfoDialog;
